import Indicator, { IndicatorType } from '../types/Indicator'

const High: Indicator = {
  type: IndicatorType.PRICE,
  value: 'high',
  label: 'High',
  fields: ['high'],
}

export default High
